// extracted by mini-css-extract-plugin
export var avatarContainer = "_67-0";
export var avatarTypingWave = "_67-i";
export var gray = "_67-f";
export var green = "_67-c";
export var icon = "_67-9";
export var image = "_67-1";
export var lg = "_67-6";
export var md = "_67-5";
export var presenceDot = "_67-b";
export var red = "_67-d";
export var sm = "_67-4";
export var status = "_67-a";
export var typingDot = "_67-h";
export var typingPill = "_67-g";
export var xl = "_67-7";
export var xs = "_67-3";
export var xxl = "_67-8";
export var xxs = "_67-2";
export var yellow = "_67-e";